module.exports = __webpack_public_path__ + "img/banner2-2@1x.837feeb1.jpg";